<template>
  <!--geurs-area-start-->
  <div class="geues-area">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="geurs-containt">
            <div class="geurs-fl logo-img">
              <a href="#"><img src="assets/img/logo_geurs22-23_simple@2x.png" alt=""/></a>
              <p>
                The Global Employability University <br />
                Ranking & Survey
              </p>
            </div>
            <div class="main-title">
              <h3>
                {{ article.title }}
              </h3>
              <p>
                {{ article.subTitle }}
              </p>
            </div>

            <div class="row">
              <div class="col-lg-6 col-md-6">
                <div class="gures-text">
                  <a href="#"><img src="assets/img/i1.png" alt=""/></a>
                  <p v-html="article.text"></p>
                </div>
              </div>
              <div class="col-lg-6 col-md-6">
                <div class="gures-text">
                  <a href="#"><img src="assets/img/i1.png" alt=""/></a>
                  <p v-html="article.textBox"></p>
                </div>
              </div>
            </div>
            <div class="gures-btn">
              <router-link to="/contact-findings" class="theme-btn"
                >Receive Key findings<br />
              </router-link>
              <p class="text-left"><small>Available from Nov.23 2022</small></p>
              <!-- <router-link to="/geurs2020" class="theme-btn">Consult GEURS 2020</router-link> -->
            </div>
          </div>
        </div>
        <div class="col-lg-6 order-first order-lg-last">
          <div class="gures-img">
            <img src="assets/img/guers-img.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--geurs-area-end-->
</template>

<script>
import { getArticleById } from '@/api/navItems';
import { translate } from '@/lib/utils';

export default {
  created() {
    let id = '5fb3a61f34941d755a466009';
    getArticleById(id).then(res => {
      this.article = translate(res);
    });
  },
  data() {
    return {
      article: {}
    };
  }
};
</script>

<style lang="scss" scoped>
.logo-img img {
  max-width: 180px;
}
</style>
